export default "__VITE_ASSET__BOJ548bL__"